import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    width: 100%;
    margin-top: 32px;
`;

export const TransactionBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const TrasactionList = styled.h2`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #000000;
`;

export const TransactionDropDown = styled.div<{ $isHidden?: boolean }>`
    ${({ $isHidden }) => $isHidden && 'display: none;'}
`;

export const TransactionHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SearchIcon = styled.img`
    width: 24px;
    height: 24px;
    cursor: pointer;
`;

export const SearchInputWrapper = styled.div`
    margin-top: 12px;
    margin-bottom: 8px;
`;

export const NoResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-top: 20px;
`;

export const ItemCardWrapper = styled.div`
    margin: 6px 0;
`;

export const Hr = styled.div`
    display: flex;
    width: 100%;
    height: 0;
    border: 1px solid #e7e7f0;
`;
